import { last } from 'lodash-es';
import { Container, Point } from 'pixi.js-legacy';
import Constants from '../constants';
import { DragManager, DragOptions } from '../managers';
import { Cutout } from './cutout';
export class Floor extends Container {
    constructor() {
        super();
        this.tiers = new Container();
        this.name = 'Floor';
        this.addChild(this.tiers);
        const dragOptions = new DragOptions();
        dragOptions.buttonMode = false;
        DragManager.getInstance().addDraggable(this, dragOptions);
    }
    diagramMode() {
        for (const tier of this.tiers.children) {
            tier.diagramMode();
        }
    }
    designMode() {
        for (const tier of this.tiers.children) {
            tier.designMode();
        }
    }
    addTier(tier) {
        if (this.tiers.children.length > 0) {
            const lastTier = last(this.tiers.children);
            tier.position.x =
                lastTier.position.x + lastTier.width + Constants.tierOffset;
        }
        this.tiers.addChild(tier);
    }
    addCutout(tierNumber, cutoutData) {
        const tier = this.tiers.children[tierNumber];
        if (tier) {
            const cutoutOptions = {
                id: cutoutData.Hash,
                tier: tier,
                position: new Point(cutoutData.X * Constants.scalingFactor, cutoutData.Y * Constants.scalingFactor),
                xDim: cutoutData.XDim * Constants.scalingFactor,
                yDim: cutoutData.YDim * Constants.scalingFactor,
            };
            tier.addCutout(new Cutout(cutoutOptions));
        }
    }
    removeCutout(id, tierNumber) {
        const tier = this.tiers.children[tierNumber];
        tier.removeCutout(id);
    }
    setCutoutSnapping(val) {
        for (const tier of this.tiers.children) {
            tier.setCutoutSnapping(val);
        }
    }
    setEdgeSnapping(val) {
        for (const tier of this.tiers.children) {
            tier.setEdgeSnapping(val);
        }
    }
    setCutoutCollision(val) {
        for (const tier of this.tiers.children) {
            tier.setCutoutCollision(val);
        }
    }
    setRenderCutoutOutline(val) {
        for (const tier of this.tiers.children) {
            tier.setRenderCutoutOutline(val);
        }
    }
}
